export enum TokenPermissions {
  SEE_BOOK = 'SEE_BOOK',
  SEE_STUDY = 'SEE_STUDY',
  SEE_HISTORIC = 'SEE_HISTORIC',
  SEE_HISTORIC_STUDIES = 'SEE_HISTORIC_STUDIES',
  SEE_HISTORIC_REPORTS = 'SEE_HISTORIC_REPORTS',
  SHARE = 'SHARE',
  SHARE_WITH_PERMS = 'SHARE_WITH_PERMS',
  DOWNLOAD = 'DOWNLOAD',
  CALL_DOCTOR = 'CALL_DOCTOR',
  OPEN_IMAGE_PREVIEW = 'OPEN_IMAGE_PREVIEW'
}

export namespace Permissions {
  export function sanitize(p: string | TokenPermissions | number): TokenPermissions | null {
    if (p == null) return null;
    switch (p) {
      case 0:
      case "SEE_BOOK":
      case TokenPermissions.SEE_BOOK:
        return TokenPermissions.SEE_BOOK;
      case 1:
      case "SEE_STUDY":
      case TokenPermissions.SEE_STUDY:
        return TokenPermissions.SEE_STUDY;
      case 2:
      case "SEE_HISTORIC":
      case TokenPermissions.SEE_HISTORIC:
        return TokenPermissions.SEE_HISTORIC;
      case 3:
      case "SEE_HISTORIC_STUDIES":
      case TokenPermissions.SEE_HISTORIC_STUDIES:
        return TokenPermissions.SEE_HISTORIC_STUDIES;
      case 4:
      case "SEE_HISTORIC_REPORTS":
      case TokenPermissions.SEE_HISTORIC_REPORTS:
        return TokenPermissions.SEE_HISTORIC_REPORTS;
      case 5:
      case "SHARE":
      case TokenPermissions.SHARE:
        return TokenPermissions.SHARE;
      case 6:
      case "SHARE_WITH_PERMS":
      case TokenPermissions.SHARE_WITH_PERMS:
        return TokenPermissions.SHARE_WITH_PERMS;
      case 7:
      case "DOWNLOAD":
      case TokenPermissions.DOWNLOAD:
        return TokenPermissions.DOWNLOAD;
      case 8:
      case "CALL_DOCTOR":
      case TokenPermissions.CALL_DOCTOR:
        return TokenPermissions.CALL_DOCTOR;
      case 9:
      case "OPEN_IMAGE_PREVIEW":
      case TokenPermissions.OPEN_IMAGE_PREVIEW:
        return TokenPermissions.OPEN_IMAGE_PREVIEW;
    }
    return null;
  }

  export function sanitizeAll(perms: any[]): TokenPermissions[] {
    if (perms == null) return [];
    return perms.map(p => sanitize(p)).filter(p => p != null) as TokenPermissions[];
  }
}